import { POST } from '../request'

export const getPresupuesto = ({ tarifa, codigo, asistencias }) =>
  POST('/api/agora/interno/presupuesto', {}, { tarifa, codigo, asistencias })
